import React from 'react';
import LoadingOverlay from 'components/pure/utils/LoadingOverlay';
import AuthActions from 'actions/AuthActions';
import 'styles/LoginPage.styl';
import '@components/login/LoginBranding.styl';
import {LoginBranding} from '@components/login/LoginBranding';
import {RouterState} from '@store/@types/util/ReactRouter';
import {MediaflySolution} from 'records/User';
import {LOGIN_REDIRECT_PARAM} from '@components/login/LoginConstants';

interface TokenLoginPageProps extends RouterState<{userId: string; token: string}> {}

class TokenLoginPage extends React.PureComponent<TokenLoginPageProps> {
  componentDidMount() {
    const {params} = this.props;
    const token = params.token;
    if (!!token) {
      const searchParams = new URLSearchParams(window.location.search);
      const tokenRedirectPath = searchParams.get(LOGIN_REDIRECT_PARAM);
      const solutionList = searchParams.getAll('solutionList') as MediaflySolution[];

      if (tokenRedirectPath) {
        AuthActions.saveNext(tokenRedirectPath);
      }

      return AuthActions.tokenLogin({
        userId: params.userId,
        token,
        solutionList,
      });
    }
  }

  render() {
    return (
      <div className="login-page">
        <LoginBranding />
        <div className="sidebar">
          <LoadingOverlay />
        </div>
      </div>
    );
  }
}

export default TokenLoginPage;
